module.exports = __webpack_public_path__ + "img/banner_h501.9fdf6fc1.webp";